<template>
  <div class="container">
    <h1>料金計算</h1>
    <form action="uk-form-horizontal">
      <div class="form-group">
        <label class="uk-form-label">長辺</label>
        <div class="uk-form-controls"><input type="text" class="form-control" v-model="longRectangle"></div>
      </div>
      <div class="form-group">
        <label class="uk-form-label">短辺</label>
        <div class="uk-form-controls"><input type="text" class="form-control" v-model="shortRectangle"></div>
      </div>
      <div class="form-group">
        <label class="uk-form-label">容量Kbyte</label>
        <div class="uk-form-controls"><input type="text" class="form-control" v-model="fileSize"></div>
      </div>
      <div class="form-group">
        <label class="uk-form-label">色係数</label>
        <div class="uk-form-controls"><input type="text" class="form-control" v-model="colorMulti"></div>
      </div>
      <div class="form-group">
        <label class="uk-form-label">基本料</label>
        <div class="uk-form-controls"><input type="text" class="form-control" v-model="sendPrice"></div>
      </div>
      <div class="form-group">
        <label class="uk-form-label">切り捨て桁</label>
        <div class="uk-form-controls"><input type="text" class="form-control" v-model="priceMathDigit"></div>
      </div>
      <vk-button @click="calculate">計算</vk-button>
    </form>
    <div>
      <p>{{ comment }}</p>
      <p class="uk-text-bold uk-text-large">計算結果：{{ price }}円</p>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Calculation',
    components: {},
    data() {
      return {
        longRectangle: 24.0,
        shortRectangle: 18.0,
        fileSize: 1.56,
        colorMulti: 1.2,
        sendPrice: 670,
        price: null,
        comment: '',
        priceMathType: 'floor',
        priceMathDigit: 10,
      };
    },
    created () {
    },
    computed: {
      convertedFileSize () {
        return Math.round(Math.sqrt(this.fileSize) * 100) / 100;
      },
      shortRectangleMulti () {
        const getRectangleMulti = (val, arr) => {
          let found = 0;
          Object.keys(arr).some(k => {
            window.console.log(k);
            const min = arr[k][0];
            const max = arr[k][1];
            const multi = arr[k][2];
            window.console.log(`${val} >= ${min} && ${val} <= ${max}`);
            if (val >= min && val <= max) {
              found = multi;
              return true;
            }
            found = multi;
          });
          return found;
        };
        return getRectangleMulti(this.shortRectangle, this.$store.state.price.shortMulti);
      },
      longRectangleMulti () {
        const getRectangleMulti = (val, arr) => {
          let found = 0;
          Object.keys(arr).some(k => {
            const min = arr[k][0];
            const max = arr[k][1];
            const multi = arr[k][2];
            window.console.log(`${val} >= ${min} && ${val} <= ${max}`);
            if (val >= min && val <= max) {
              found = multi;
              return true;
            }
            found = multi;
          });
          return found;
        };
        return getRectangleMulti(this.longRectangle, this.$store.state.price.longMulti);
      }
    },
    methods: {
      calculate() {
        window.console.log('calculate');
        this.comment = `長辺(${this.longRectangle})×短辺(${this.shortRectangle})×√容量MB(${this.convertedFileSize})×短辺係数(${this.shortRectangleMulti})×長辺係数(${this.longRectangleMulti})×色係数(${this.colorMulti})+基本料(${this.sendPrice})`;
        this.price = this.longRectangle * this.shortRectangle * this.convertedFileSize *
          this.shortRectangleMulti * this.longRectangleMulti * this.colorMulti +
          this.sendPrice;
        this.price = Math.floor(this.price / this.priceMathDigit) * this.priceMathDigit;
      },
    },
  };
</script>

<style scoped lang="scss">
</style>
